import React, { useEffect } from 'react';

// Former styled.div root. Global element rules (a, h1-h5, .cursor-pointer) now
// live in client/tailwind.css.
//
// The `dark` class goes on <html>, not on this div. Two reasons: anything
// portalled to document.body (react-toastify, react-tooltip, Modal) renders
// OUTSIDE this subtree and would otherwise stay light while everything else
// flipped; and the .dark token overrides in tailwind.css cascade from the
// document root. The existing `@custom-variant dark (&:where(.dark, .dark *))`
// matches html.dark unchanged.
//
// The surface colors are tokens rather than bg-white/text-black so they follow
// the theme instead of pinning the app to Arctic.
export const AppStyled = ({ dark, children }: { dark?: boolean; children: React.ReactNode }) => {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', !!dark);
    return () => root.classList.remove('dark');
  }, [dark]);

  return (
    <div className="flex h-full w-full overflow-auto bg-page text-fg-1">
      {children}
    </div>
  );
};
